import { FunctionComponent, SVGProps } from 'react';

export const OpenBookReaderLightIcon: FunctionComponent<SVGProps<SVGSVGElement>> = (props) => {
    return (
        <svg
            aria-hidden="true"
            focusable="false"
            role="img"
            viewBox="0 0 512 512"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <path d="M459.9 192c-.625 0-1.375 0-2 .125C408 194.9 317.4 205.1 256 239.6c-61.38-34.5-152-44.75-201.9-47.5C53.5 192 52.75 192 52.12 192C31.75 192 0 206.4 0 242.2v177.1C0 447 21.25 469 48.38 470.4c34.38 1.875 120.5 9.125 177 37.5C229.1 510.2 235 511.5 240 511.9l32 .0208c5-.375 9.1-1.688 14.62-4.062c56.5-28.38 142.6-35.63 177-37.5C490.8 469 512 447 512 420.2V242.2C512 206.4 480.3 192 459.9 192zM239.9 479.3C239.8 479.2 240 479.4 239.9 479.3c-59.63-30-144.6-38.44-189.9-40.81C39.88 437.9 32 429.9 32 420.2V242.2c0-6.125 1.75-10 5.875-13.25C42.38 225.6 48.38 224 52.38 224C89.38 226.1 181.6 234.6 240 267.4L239.9 479.3zM480 420.2c0 9.625-7.875 17.63-18 18.25c-45.25 2.375-130.2 10.81-189.9 40.81c-.125 .125 .125 0 0 0L272 267.4C330.4 234.6 422.6 226.1 459.5 224h.375C460.1 224 480 224.5 480 242.2V420.2zM256 192c53 0 96-43 96-96s-43-96-96-96S160 43 160 96S203 192 256 192zM256 32c35.25 0 64 28.75 64 64s-28.75 64-64 64S192 131.2 192 96S220.8 32 256 32z" />
        </svg>
    );
};

export default OpenBookReaderLightIcon;
